import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireService } from 'src/app/services/questionnaire/questionnaire.service';
import { OrganisationService } from '../../services/organisation/organisation.service';
import { MetricIconService } from 'src/app/services/metrics/metrics-icons.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import moment from 'moment-timezone';

@Component({
  selector: 'app-create-survey-from-scratch',
  templateUrl: './create-survey-from-scratch.component.pug',
  styleUrls: ['./create-survey-from-scratch.component.scss'],
  standalone: false
})
export class CreateSurveyFromScratchComponent implements OnInit {
  @Input() isEditTitle = false;
  @Input() initialise = [];
  @Input() questionnaireTitle = '';
  @Input() max_questions_limit = 5;
  @Input() survey_type = "exit";
  public cancelClick: EventEmitter<any> = new EventEmitter();
  public skipClick: EventEmitter<any> = new EventEmitter();
  public nextClick: EventEmitter<any> = new EventEmitter();
  questionnaireId: string = '';
  // refer to OMNI-1455 in case of clarification needed about the regex
  titlePattern=new RegExp(/[^a-zA-Z0-9 _\-():',.\/&]+/);
  initialTitle = '';
  invalidTitle = false;
  wrongPattern = false;
  metrics: any[] = [];
  selectedMetric={};
  disableButton = false;
  errors = [
    {'name': 'wrongPattern', 'msg': $localize`The special characters entered cannot be used.`, 'enabled': false},
    {'name': 'invalidTitle', 'msg': $localize`A survey with this title already exists`, 'enabled': false},
  ];

  constructor(public bsModalRef: BsModalRef,
              private questionnaireService: QuestionnaireService,
              private organisationService: OrganisationService,
              private metricIconService: MetricIconService,
              private permission: PermissionsService
             ) { }

  ngOnInit(): void {
    /*
       The following regular expression is designed to match any character
       that is not a word character, whitespace, or specific symbols. It includes ranges
       for common language accent marks, additional Latin script characters, CJK characters,
       and specific non-Latin script characters.
    */
    this.titlePattern = new RegExp(
      /[^\w\s\-():',.\/&À-ÖØ-öø-ÿĀ-ž一-龯请β。，、！¡¿«»„“‘‚‹›]+/
    );
    if (!this.isEditTitle || !this.questionnaireTitle){
      this.generateQuestionnaireTitle();
    }
    this.questionnaireService.getMetrics(this.survey_type).subscribe((res)=>{
      this.metrics = res;
      this.metrics.forEach((metric) => {
        // if initialise has the metrics then it has to be true
        this.selectedMetric[metric.id]=this.initialise.length!=0&&this.initialise.findIndex(_metric=>_metric == metric.id)!=-1;
      });
    });
    this.organisationService.getOrganisation().subscribe(res => {
      if (this.survey_type == 'pulse') {
        this.max_questions_limit = res['pulse_questionnaire_limit'];
      }
      else {
        this.max_questions_limit = res['questionnaire_limit']
      }
    });
    this.initialTitle = this.questionnaireTitle;
    this.setValidations();
  }

  generateQuestionnaireTitle(): void{
    const today = new Date();
    const dateString = moment().startOf('day').format('ll');
    if(this.survey_type == 'pulse') {
      let name = $localize`Pulse survey ` + dateString;
      this.verifyQuestionnaireTitle(name);
    }else if(this.survey_type == 'exit'){
      let name = $localize`Exit survey ` + dateString;
      this.verifyQuestionnaireTitle(name);
    }
  }

  verifyQuestionnaireTitle(name): void{
    var regExp = /\(([^)]*)\)[^(]*$/;
    this.questionnaireService.getNewQuestionnaireTitle(name).subscribe(res=>{
      const next = res['questionnaires'].map(q=> {
        const matches = regExp.exec(q['name']);
        if (matches?.length==2 && !isNaN(Number(matches[1]))) return Number(matches[1]);
        return 0;
      }).sort()[res['questionnaires'].length-1]+1;
      if (next) this.questionnaireTitle = name + ` (${next})`;
      else this.questionnaireTitle = name;
      return name;
    })
  }

  cancel(){
    this.cancelClick.emit({});
    this.bsModalRef.hide();
  }
  skip(){
    this.permission.setNavCheck(true);
    this.skipClick.emit({});
    this.bsModalRef.hide();
  }
  next(){
    this.permission.setNavCheck(true);
    this.questionnaireService.validateQuestionnaireTitle(this.questionnaireTitle, this.questionnaireId).subscribe(res => {
      if (res.data.exists) {
        this.invalidTitle = true;
        this.setError('invalidTitle', true);
      } else {
        this.nextClick.emit({
          'title': this.questionnaireTitle,
          'selected_metrics': Object.keys(this.selectedMetric).filter(m => this.selectedMetric[m])
        });
        this.questionnaireTitle = '';
        this.bsModalRef.hide();
      }
    }, err => {
    });
  }

  titleChange(title){
    this.setError('invalidTitle', false);

    this.invalidTitle=false;
    let patternMatch = this.titlePattern.test(title);
    this.wrongPattern = patternMatch;
    if (this.wrongPattern) {
      this.setError('wrongPattern', true);
    } else if (!this.wrongPattern)  {
      this.setError('wrongPattern', false);
    }
    this.setValidations();
  }

  setError(name: string, enabled: boolean) {
    this.errors.find(o => o.name === name)!.enabled = enabled;
    this.errors = [...this.errors];
  }

  selectMetric(metricId): void {
    this.selectedMetric[metricId] = !this.selectedMetric[metricId];
    this.setValidations();
  }

  setValidations(){
    let numberOfSelectedMetric = Object.keys(this.selectedMetric).filter(metric=>this.selectedMetric[metric]).length;
    const titleUnchanged: boolean = this.questionnaireTitle == this.initialTitle;
    const isDuplicating: boolean = !!(this.isEditTitle && this.questionnaireId && this.questionnaireId !== '');
    const shouldDisableForUnchangedTitle: boolean = titleUnchanged && !isDuplicating;
    
    this.disableButton = numberOfSelectedMetric>this.max_questions_limit || 
                        this.wrongPattern || 
                        this.invalidTitle || 
                        shouldDisableForUnchangedTitle || 
                        this.questionnaireTitle.length <= 0;
  }

  getMetricIcon(metric){
    return this.metricIconService.getMetricIcon(metric);
  }
}
